import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

import {
  getCTAButtons,
  getDefaultCTAButtons,
  TransformedCTAButtonsResponse,
  transformCTAButtonsResponse,
  CTAButtonsResource,
} from 'Services/CTAButtons/CTAButtonsUtils'

const CTA_BUTTONS = 'CTA_BUTTONS'

export const CTAButtonsApi = createApi({
  reducerPath: 'ctaButtonsApi',
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_BASE_URL,
    credentials: 'include',
  }),
  tagTypes: [CTA_BUTTONS],
  endpoints: (builder) => ({
    getCTAButtons: builder.query<
      TransformedCTAButtonsResponse,
      { instId: string | number; locId: string | number }
    >({
      queryFn: async({ instId, locId }, _queryApi, _extraOptions, fetchWithBQ) => {
        const ctaResponse = await fetchWithBQ(getCTAButtons({ instId, locId })) 
        const transformedCTAResponse = transformCTAButtonsResponse(ctaResponse.data)
        // checks if missing bg_color or font_color in any of the ctaButtons
        const needsDefaultConfig = transformedCTAResponse?.ctaButtons?.some(
          (button: Partial<CTAButtonsResource>) => !button.bg_color || !button.font_color
        )
        // makes second request to get default ctaButtons if any of the ctaButtons are missing bg_color or font_color
        if (needsDefaultConfig) {
          const defaultCTAResponse = await fetchWithBQ(getDefaultCTAButtons({ instId, locId }))
          const { ctaButtons: defaultCTAButtons } = transformCTAButtonsResponse(defaultCTAResponse.data)
        
          // combines the default ctaButtons with the ctaButtons from the first request
          const combinedResponse = transformedCTAResponse?.ctaButtons?.map((button: Partial<CTAButtonsResource>) => { 
            const defaultButton = defaultCTAButtons.find((defaultButton: Partial<CTAButtonsResource>) => defaultButton.actionid === button.actionid)
            return {
              ...button,
              bg_color: button?.bg_color || defaultButton?.bg_color,
              font_color: button?.font_color || defaultButton?.font_color,
            }
          })
          return { data: { ...transformedCTAResponse, ctaButtons: combinedResponse}}
        }
        return { data: transformedCTAResponse }
      }, 
    })
  }),
})

export const { useGetCTAButtonsQuery } = CTAButtonsApi
